export function sleep(msec: number) {
  return new Promise((resolve) => setTimeout(resolve, Math.max(msec, 0)));
}

/**
 * Elementのwindowからの絶対数
 * @param element
 */
export const getAbsoluteTop = (element: HTMLElement) => {
  const {top = 0} = element.getBoundingClientRect() || {};
  const windowScrollY = window.scrollY || window.pageYOffset;
  return top + windowScrollY;
};

/**
 * Elementがすでにスクロール済みかどうか
 * @param element
 */
export const isScrolledOver = (element: HTMLElement) => {
  const windowScrollY = window.scrollY || window.pageYOffset;
  const top = getAbsoluteTop(element);
  return windowScrollY + window.innerHeight > top;
};
